export default "__VITE_ASSET__B2rZfoRi__ 1200w";